import moment from "moment"

export default {
  adjustOffsetToDST(offset) {
		const isDST = moment().isDST()
    if (!isDST) {
     return offset - 60
    }
    return offset
  },
  numericalTime(time) {
    return Number(time.replace(/:/g, ""))
  },
  normalizeDayOfWeek(date) {
    let dow = date.day()
    return dow == 0 ? 6 : dow - 1
  },
  incrementDow(dow) {
    return dow >= 6 ? 0 : dow + 1
  },
  todaysDow(options) {
    let today = new Date()
    if (options && options.utc) {
      return this.normalizeDayOfWeek(moment.utc(today))
    } else {
      return this.normalizeDayOfWeek(moment(today))
    }
  },
  todaysTime() {
    let today = new Date()
    return moment(today).format("HH:mm")
  },
  todaysDate() {
    let today = new Date()
    return moment(today).format("YYYY-MM-DD")
  },
  daysDiff(from, to) {
    const duration = moment.duration(from.diff(to))
    const days = duration.asDays()
    const fixedDays = Number(days.toFixed(0))
    if (fixedDays >= 1) {
      return `${fixedDays} ${fixedDays > 1 ? "days" : "day"}`
    } else if (fixedDays < 0) {
      return `${Math.abs(fixedDays)} ${
        fixedDays < -1 ? "days" : "day"
      } ago`
    }
  },
  timeDiff(from, to) {
			const duration = moment.duration(from.diff(to))
      const daysDiff = this.daysDiff(from, to)
      if (daysDiff) {
        return daysDiff
      }
			const hours = duration.asHours()
			const fixedHours = Number(hours.toFixed(0))
			if (fixedHours >= 1) {
				return `${fixedHours} ${fixedHours > 1 ? "hours" : "hour"}`
			} else if (fixedHours < 0) {
				return `${Math.abs(fixedHours)} ${
					hours < -1 ? "hours" : "hour"
				} ago`
			}
			const minutes = duration.asMinutes()
			const fixedMinutes = Number(minutes.toFixed(0))
			if (fixedMinutes > 0) {
				return `${fixedMinutes} ${
					fixedMinutes > 1 ? "minutes" : "minute"
				}`
			} else {
				return `${Math.abs(fixedMinutes)} ${
					fixedMinutes < -1 ? "minutes" : "minute"
				} ago`
			}
  },
  isBetweenTimes(time, startTime, endTime) {
    const date = time.format("YYYY-MM-DD")
    const start = moment.utc(`${date} ${startTime}`, "YYYY-MM-DD HH:mm")
    const end = moment.utc(`${date} ${endTime}`, "YYYY-MM-DD HH:mm").subtract(1, "m")
    return time.isSameOrAfter(start) && time.isSameOrBefore(end)
  },
  isBetweenDays(date, startDate, endDate) {
    const start = moment(startDate, "YYYY-MM-DD")
    const end = moment(endDate, "YYYY-MM-DD")
    return date.isSameOrAfter(start) && date.isSameOrBefore(end)
  },
  isBeforeTime(time, endTime) {
    return time.isBefore(moment(endTime, "HH:mm"))
  },
  isBeforeDay(day, endDay) {
    return day.isBefore(endDay, "day")
  },
  isSameDay(day, endDay) {
    return day.isSame(endDay, "day")
  },
  findDowFromToday(dowToFind) {
    const now = moment()
    while (this.normalizeDayOfWeek(now) !== dowToFind) { 
      now.add(1, "day")
    }
    return now
  },
  generateTimeSlots(schedules, inStock, isToday, minuteInterval, offsetMinutes) {
    let totalSlots = []
    minuteInterval = minuteInterval ? minuteInterval : 60
    offsetMinutes = offsetMinutes ? offsetMinutes : 60
    if (schedules) {
        const today = moment()
        const cutOffDate = moment(today, "HH:mm").add(offsetMinutes, "minutes")
        let hasAsap = false
        schedules.forEach(schedule => {
            let scheduleSlots = []
            let openTime = moment(schedule.openTime, "HH:mm")
            let openTimeMins = openTime.minutes()
            if (openTimeMins > 0) {
              openTime.minutes(0)
              openTime.add(1, "h")
            }
            const closeTime = moment(schedule.closeTime, "HH:mm")
            const minutesDiff = closeTime.diff(openTime, "minutes")
            const intervals = minutesDiff >= minuteInterval ? minutesDiff / minuteInterval : 0
            const startTime = moment(openTime, "HH:mm").format("HH:mm")
            if (isToday && inStock && !hasAsap) {
              hasAsap = true
              scheduleSlots.push({
                text: "ASAP",
                time: -1,
                weight: -1,
                id: -1
              })
            }
            for (var i = 0; i < intervals; i++) {
                let date = moment(startTime, "HH:mm").add(minuteInterval * i, "minutes")
                if (isToday && date.isSameOrBefore(cutOffDate)) {
                  continue
                }
                const numerical = this.numericalTime(date.format("HH:mm:ss"))
                let slot = {
                    text: date.format("h:mm a"),
                    time: date.format("HH:mm:ss"), 
                    weight: numerical,
                    id: numerical
                }
                scheduleSlots.push(slot)
            }
            totalSlots = totalSlots.concat(scheduleSlots)
        })
    }
    return totalSlots
  },
  normalizeSchedule(openingHours, offset) {
    let schedule = {
      0: [],
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
      6: []
    }

    openingHours.forEach(hour => {
      const schedules = this.createScheduleFromRange(hour.open_time, hour.close_time, hour.day_of_week, offset)
      for (let scheduleDow in schedules) {
        schedule[scheduleDow] = schedule[scheduleDow].concat(schedules[scheduleDow])
      }
    })

    return schedule
  },
  offsetScheduleStart(schedules, offsetSchedules, offsetMinutes) {
    for(let dow in schedules) {
      const dailySchedules = schedules[dow]
      let dailyOffsetSchedules = offsetSchedules[dow]
      if (dailySchedules && dailySchedules.length > 0 && dailyOffsetSchedules && dailyOffsetSchedules.length > 0) {
        dailySchedules
          .forEach((dailySchedule) => {
            if (dailySchedule.dow != dailySchedule.rangesFrom) {
              return
            }
            const openTime = moment.utc(dailySchedule.openTime, "HH:mm")
            let nearestOpenTime = null
            let nearestOpenTimeDiff = null

            dailyOffsetSchedules.forEach(offsetSchedule => {
              const offsetOpenTime = moment.utc(offsetSchedule.openTime, "HH:mm")
              const offsetCloseTime = moment.utc(offsetSchedule.closeTime, "HH:mm")
              const diff = Math.abs(openTime.diff(offsetOpenTime, "m"))
              if ((!nearestOpenTime || diff <  nearestOpenTimeDiff) && openTime.isBefore(offsetCloseTime)) {
                nearestOpenTime = offsetOpenTime
                nearestOpenTimeDiff = diff
              }
            })

            if (nearestOpenTime && openTime.isSameOrBefore(nearestOpenTime)) {
              nearestOpenTime.add(offsetMinutes, "m")
              const newOpenTime = nearestOpenTime.format("HH:mm")
              if (this.numericalTime(newOpenTime) < this.numericalTime(dailySchedule.closeTime)) {
                dailySchedule.openTime = nearestOpenTime.format("HH:mm")
              } else {
                dailySchedule.openTime = "00:00"
                dailySchedule.closeTime = "00:00"
              }
            }
          })
      }
    }
  },
  createScheduleFromRange(openTime, closeTime, dow, timezoneOffset) {
    let localOpenTime = moment.utc(openTime, "HH:mm:ss").add(timezoneOffset, "m").format("HH:mm:ss")
    let localCloseTime = moment.utc(closeTime, "HH:mm:ss").add(timezoneOffset, "m").format("HH:mm:ss")
    let numOpenTime =  Number(localOpenTime.replace(/:/g, ""))
    let numCloseTime = Number(localCloseTime.replace(/:/g, ""))
    let schedule = {}
    let nextDay = dow == 6 ? 0 : dow + 1
    schedule[dow] = []
    schedule[nextDay] = []
    let scheduleDay = schedule[dow]
    if (
      localCloseTime == "00:00:00" &&
      closeTime == "00:00:00"
    ) {
      scheduleDay.push({
        openTime: "00:00:00",
        closeTime: "24:00:00",
        dow: dow,
        rangesFrom: dow
      })
    } else if (numOpenTime > numCloseTime) {
      let scheduleNextDay = schedule[nextDay]
      if (localOpenTime != "24:00:00") {
        scheduleDay.push({
          openTime: localOpenTime,
          closeTime: "24:00:00",
          dow: dow,
          rangesFrom: dow
        })
      }
      if (localCloseTime != "00:00:00") {
        scheduleNextDay.push({
          openTime: "00:00:00",
          closeTime: localCloseTime,
          dow: nextDay,
          rangesFrom: dow
        })
      }
    } else {
      scheduleDay.push({
        openTime: localOpenTime,
        closeTime: localCloseTime,
        dow: dow,
        rangesFrom: dow
      })
    }
    return schedule
  },
  isWithinBounds(bounds, targetRange) {
    const boundOpenTime = moment.utc(bounds.openTime, "HH:mm:ss")
    const boundCloseTime = moment.utc(bounds.closeTime, "HH:mm:ss")
    const openTime = moment.utc(targetRange.openTime, "HH:mm:ss")
    const closeTime = moment.utc(targetRange.closeTime, "HH:mm:ss")

    if (boundCloseTime.isBefore(boundOpenTime, "m")) {
      boundCloseTime.add(1, "d")
    }

    if (closeTime.isBefore(openTime, "m")) {
      closeTime.add(1, "d")
    }

    const openTimeWithinBounds = openTime.isBetween(boundOpenTime, boundCloseTime, "m", "[]")
    const closeTimeWithinBounds = closeTime.isBetween(boundOpenTime, boundCloseTime, "m", "[]")
    if (openTimeWithinBounds && closeTimeWithinBounds) {
      return {
        openTimeInBounds: true,
        closeTimeInBounds: true
      }
    } else if (!closeTimeWithinBounds && !openTimeWithinBounds) {
      const boundsWithinTargetRange = boundOpenTime.isBetween(openTime, closeTime, "m", "[]") && boundCloseTime.isBetween(openTime, closeTime, "m", "[]")
      if (boundsWithinTargetRange) {
        return {
          openTimeInBounds: false,
          closeTimeInBounds: false,
          boundsInTargetRange: true
        }
      } else {
        return {
          openTimeInBounds: false,
          closeTimeInBounds: false
        }
      }
    } else if (!closeTimeWithinBounds) {
      return {
        openTimeInBounds: true,
        closeTimeInBounds: false
      }
    } else if (!openTimeWithinBounds) {
      return {
        openTimeInBounds: false,
        closeTimeInBounds: true
      }
    }
    return {
      openTimeInBounds: false,
      closeTimeInBounds: false
    }
  },
  intersectWithinRanges(bounds, targetRange) {
    const withinBounds = this.isWithinBounds(bounds, targetRange)
    if (withinBounds.openTimeInBounds && withinBounds.closeTimeInBounds) {
      return targetRange
    } else if (!withinBounds.closeTimeInBounds && !withinBounds.openTimeInBounds) {
      if (withinBounds.boundsInTargetRange) {
        return bounds
      } else {
        return null
      }
    } else if (!withinBounds.closeTimeInBounds) {
      return Object.assign({}, targetRange, {
        closeTime: bounds.closeTime
      })
    } else if (!withinBounds.openTimeInBounds) {
      return Object.assign({}, targetRange, {
        openTime: bounds.openTime
      })
    }
    return null
  }
}